import React, { useState, Component } from 'react';
import { Plus, Eye, Edit2, Trash2, Search } from 'lucide-react';
import { NuovaRichiestaModal } from '../components/modals/NuovaRichiestaModal';
import { ConfirmSituazioneModal } from '../components/modals/ConfirmSituazioneModal';
import { AustriaFlag, GermanyFlag, FranceFlag } from '../components/icons/CountryFlags';
interface EsoneroRequest {
  id: string;
  ragioneSociale: string;
  partitaIva: string;
  cantiere: string;
  situazioneContributiva: 'Regolare' | 'Non regolare';
  dataInvio: string;
  paese: string;
}
interface RichiesteEsoneroPageProps {
  onViewDetail: (requestId: string, companyName: string, submissionDate: string) => void;
}
const initialMockData: EsoneroRequest[] = [{
  id: 'ESO-2024-001',
  ragioneSociale: 'Costruzioni Italia S.r.l.',
  partitaIva: '12345678901',
  cantiere: 'Cantiere Parigi Centro',
  situazioneContributiva: 'Regolare',
  dataInvio: '10/01/2024',
  paese: 'Francia'
}, {
  id: 'ESO-2024-002',
  ragioneSociale: 'Edilizia Moderna S.p.A.',
  partitaIva: '98765432109',
  cantiere: 'Cantiere Berlino Nord',
  situazioneContributiva: 'Regolare',
  dataInvio: '25/01/2024',
  paese: 'Germania'
}, {
  id: 'ESO-2024-003',
  ragioneSociale: 'Impresa Edile Roma',
  partitaIva: '11223344556',
  cantiere: 'Cantiere Vienna Est',
  situazioneContributiva: 'Non regolare',
  dataInvio: '15/01/2024',
  paese: 'Austria'
}, {
  id: 'ESO-2024-004',
  ragioneSociale: 'Costruzioni del Sud',
  partitaIva: '55667788990',
  cantiere: 'Cantiere Lione Ovest',
  situazioneContributiva: 'Regolare',
  dataInvio: '28/03/2024',
  paese: 'Francia'
}, {
  id: 'ESO-2024-005',
  ragioneSociale: 'Edil Costruzioni',
  partitaIva: '22334455667',
  cantiere: 'Cantiere Monaco Sud',
  situazioneContributiva: 'Regolare',
  dataInvio: '05/03/2024',
  paese: 'Germania'
}, {
  id: 'ESO-2024-006',
  ragioneSociale: 'Costruzioni Italia S.r.l.',
  partitaIva: '12345678901',
  cantiere: 'Cantiere Salisburgo Centro',
  situazioneContributiva: 'Regolare',
  dataInvio: '08/02/2024',
  paese: 'Austria'
}, {
  id: 'ESO-2024-007',
  ragioneSociale: 'Gruppo Edile Milano',
  partitaIva: '33445566778',
  cantiere: 'Cantiere Marsiglia Porto',
  situazioneContributiva: 'Non regolare',
  dataInvio: '12/01/2024',
  paese: 'Francia'
}, {
  id: 'ESO-2024-008',
  ragioneSociale: 'Edilizia Moderna S.p.A.',
  partitaIva: '98765432109',
  cantiere: 'Cantiere Francoforte Est',
  situazioneContributiva: 'Regolare',
  dataInvio: '20/03/2024',
  paese: 'Germania'
}, {
  id: 'ESO-2024-009',
  ragioneSociale: 'Impresa Edile Roma',
  partitaIva: '11223344556',
  cantiere: 'Cantiere Innsbruck Nord',
  situazioneContributiva: 'Regolare',
  dataInvio: '02/04/2024',
  paese: 'Austria'
}, {
  id: 'ESO-2024-010',
  ragioneSociale: 'Costruzioni del Sud',
  partitaIva: '55667788990',
  cantiere: 'Cantiere Nizza Costa',
  situazioneContributiva: 'Regolare',
  dataInvio: '10/02/2024',
  paese: 'Francia'
}];
function getCountryFlag(paese: string) {
  switch (paese) {
    case 'Francia':
      return FranceFlag;
    case 'Germania':
      return GermanyFlag;
    case 'Austria':
      return AustriaFlag;
    default:
      return null;
  }
}
export function RichiesteEsoneroPage({
  onViewDetail
}: RichiesteEsoneroPageProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [mockData, setMockData] = useState<EsoneroRequest[]>(initialMockData);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [pendingChange, setPendingChange] = useState<{
    requestId: string;
    currentStatus: 'Regolare' | 'Non regolare';
    newStatus: 'Regolare' | 'Non regolare';
    companyName: string;
  } | null>(null);
  const filteredData = mockData.filter(request => {
    const query = searchQuery.toLowerCase();
    return request.ragioneSociale.toLowerCase().includes(query) || request.partitaIva.toLowerCase().includes(query) || request.cantiere.toLowerCase().includes(query) || request.situazioneContributiva.toLowerCase().includes(query) || request.dataInvio.toLowerCase().includes(query) || request.paese.toLowerCase().includes(query);
  });
  const handleSwitchClick = (request: EsoneroRequest) => {
    const newStatus: 'Regolare' | 'Non regolare' = request.situazioneContributiva === 'Regolare' ? 'Non regolare' : 'Regolare';
    setPendingChange({
      requestId: request.id,
      currentStatus: request.situazioneContributiva,
      newStatus: newStatus,
      companyName: request.ragioneSociale
    });
    setIsConfirmModalOpen(true);
  };
  const handleConfirmChange = () => {
    if (pendingChange) {
      setMockData(prevData => prevData.map(request => request.id === pendingChange.requestId ? {
        ...request,
        situazioneContributiva: pendingChange.newStatus
      } : request));
    }
    setIsConfirmModalOpen(false);
    setPendingChange(null);
  };
  const handleCancelChange = () => {
    setIsConfirmModalOpen(false);
    setPendingChange(null);
  };
  return <div className="space-y-4 lg:space-y-6" data-id="element-487">
      {/* Header with title and action button */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-488">
        <div data-id="element-489">
          <h1 className="text-xl lg:text-2xl font-bold text-gray-900" data-id="element-490">
            Richieste di Esonero
          </h1>
          <p className="text-sm lg:text-base text-gray-600 mt-1" data-id="element-491">
            Gestisci le richieste di esonero per i lavoratori distaccati
          </p>
        </div>
        <button onClick={() => setIsModalOpen(true)} className="flex items-center justify-center gap-2 px-4 py-2 text-white rounded-lg transition-colors whitespace-nowrap" style={{
        backgroundColor: '#172637'
      }} onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = '#2d4a63';
      }} onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = '#172637';
      }} data-id="element-492">
          <Plus size={20} data-id="element-493" />
          <span className="hidden sm:inline" data-id="element-494">Nuova Richiesta</span>
          <span className="sm:hidden" data-id="element-495">Nuova</span>
        </button>
      </div>

      {/* Search Bar */}
      <div className="bg-white rounded-lg shadow p-3 lg:p-4" data-id="element-496">
        <div className="relative" data-id="element-497">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} data-id="element-498" />
          <input type="text" placeholder="Cerca..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm lg:text-base" data-id="element-499" />
        </div>
      </div>

      {/* Table - Desktop */}
      <div className="hidden lg:block bg-white rounded-lg shadow overflow-hidden" data-id="element-500">
        <div className="overflow-x-auto" data-id="element-501">
          <table className="w-full" data-id="element-502">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-503">
              <tr data-id="element-504">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-505">
                  Ragione Sociale
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-506">
                  Partita IVA
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-507">
                  Cantiere
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-508">
                  Situazione Contributiva
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-509">
                  Data Invio
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-510">
                  Paese
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-511">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-512">
              {filteredData.length > 0 ? filteredData.map(request => {
              const FlagComponent = getCountryFlag(request.paese);
              return <tr key={request.id} className="hover:bg-gray-50 transition-colors" data-id="element-513">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-514">
                        {request.ragioneSociale}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-515">
                        {request.partitaIva}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-516">
                        {request.cantiere}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-517">
                        <button onClick={() => handleSwitchClick(request)} className="group relative inline-flex items-center" data-id="element-518">
                          <div className={`relative inline-flex h-6 w-11 items-center rounded-full border-2 transition-colors ${request.situazioneContributiva === 'Regolare' ? 'bg-green-100 border-green-600' : 'bg-red-100 border-red-600'}`} data-id="element-519">
                            <span className={`inline-block h-3 w-3 transform rounded-full transition-transform ${request.situazioneContributiva === 'Regolare' ? 'translate-x-6 bg-green-600' : 'translate-x-1 bg-red-600'}`} data-id="element-520" />
                          </div>
                          <span className={`ml-3 text-xs font-medium ${request.situazioneContributiva === 'Regolare' ? 'text-green-700' : 'text-red-700'}`} data-id="element-521">
                            {request.situazioneContributiva}
                          </span>
                        </button>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-522">
                        {request.dataInvio}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-523">
                        <div className="flex items-center gap-2" data-id="element-524">
                          {FlagComponent && <div className="w-8 h-6 rounded overflow-hidden shadow-sm flex-shrink-0" data-id="element-525">
                              <FlagComponent className="w-full h-full object-cover" data-id="element-526" />
                            </div>}
                          <span data-id="element-527">{request.paese}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-528">
                        <div className="flex items-center gap-2" data-id="element-529">
                          <button onClick={() => onViewDetail(request.id, request.ragioneSociale, request.dataInvio)} className="p-1 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors" title="Visualizza" data-id="element-530">
                            <Eye size={18} data-id="element-531" />
                          </button>
                          <button className="p-1 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded transition-colors" title="Modifica" data-id="element-532">
                            <Edit2 size={18} data-id="element-533" />
                          </button>
                          <button className="p-1 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded transition-colors" title="Elimina" data-id="element-534">
                            <Trash2 size={18} data-id="element-535" />
                          </button>
                        </div>
                      </td>
                    </tr>;
            }) : <tr data-id="element-536">
                  <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-537">
                    Nessun risultato trovato per "{searchQuery}"
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Cards - Mobile */}
      <div className="lg:hidden space-y-4" data-id="element-538">
        {filteredData.length > 0 ? filteredData.map(request => {
        const FlagComponent = getCountryFlag(request.paese);
        return <div key={request.id} className="bg-white rounded-lg shadow p-4 space-y-3" data-id="element-539">
                <div className="flex items-start justify-between" data-id="element-540">
                  <div className="flex-1" data-id="element-541">
                    <h3 className="font-semibold text-gray-900 text-sm" data-id="element-542">
                      {request.ragioneSociale}
                    </h3>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-543">
                      P.IVA: {request.partitaIva}
                    </p>
                  </div>
                  <button onClick={() => handleSwitchClick(request)} className="flex items-center gap-2" data-id="element-544">
                    <div className={`relative inline-flex h-6 w-11 items-center rounded-full border-2 transition-colors ${request.situazioneContributiva === 'Regolare' ? 'bg-green-100 border-green-600' : 'bg-red-100 border-red-600'}`} data-id="element-545">
                      <span className={`inline-block h-3 w-3 transform rounded-full transition-transform ${request.situazioneContributiva === 'Regolare' ? 'translate-x-6 bg-green-600' : 'translate-x-1 bg-red-600'}`} data-id="element-546" />
                    </div>
                  </button>
                </div>

                <div className="space-y-2 text-sm" data-id="element-547">
                  <div className="flex items-center justify-between" data-id="element-548">
                    <span className="text-gray-600" data-id="element-549">Cantiere:</span>
                    <span className="text-gray-900 font-medium" data-id="element-550">
                      {request.cantiere}
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-551">
                    <span className="text-gray-600" data-id="element-552">Situazione:</span>
                    <span className={`text-xs font-medium ${request.situazioneContributiva === 'Regolare' ? 'text-green-700' : 'text-red-700'}`} data-id="element-553">
                      {request.situazioneContributiva}
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-554">
                    <span className="text-gray-600" data-id="element-555">Data Invio:</span>
                    <span className="text-gray-900 font-medium" data-id="element-556">
                      {request.dataInvio}
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-557">
                    <span className="text-gray-600" data-id="element-558">Paese:</span>
                    <div className="flex items-center gap-2" data-id="element-559">
                      {FlagComponent && <div className="w-6 h-4 rounded overflow-hidden shadow-sm flex-shrink-0" data-id="element-560">
                          <FlagComponent className="w-full h-full object-cover" data-id="element-561" />
                        </div>}
                      <span className="text-gray-900 font-medium" data-id="element-562">
                        {request.paese}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-2 pt-2 border-t border-gray-200" data-id="element-563">
                  <button onClick={() => onViewDetail(request.id, request.ragioneSociale, request.dataInvio)} className="flex-1 flex items-center justify-center gap-2 px-3 py-2 text-sm text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors" data-id="element-564">
                    <Eye size={16} data-id="element-565" />
                    Visualizza
                  </button>
                  <button className="flex-1 flex items-center justify-center gap-2 px-3 py-2 text-sm text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition-colors" data-id="element-566">
                    <Edit2 size={16} data-id="element-567" />
                    Modifica
                  </button>
                  <button className="p-2 text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors" data-id="element-568">
                    <Trash2 size={16} data-id="element-569" />
                  </button>
                </div>
              </div>;
      }) : <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500" data-id="element-570">
            Nessun risultato trovato per "{searchQuery}"
          </div>}
      </div>

      {/* Table footer with pagination info */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-4 py-3 bg-white rounded-lg shadow" data-id="element-571">
        <div className="text-sm text-gray-700 text-center sm:text-left" data-id="element-572">
          Mostrando <span className="font-medium" data-id="element-573">1</span> a{' '}
          <span className="font-medium" data-id="element-574">{filteredData.length}</span> di{' '}
          <span className="font-medium" data-id="element-575">{filteredData.length}</span> risultati
        </div>
        <div className="flex gap-2 justify-center" data-id="element-576">
          <button className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 transition-colors" data-id="element-577">
            Precedente
          </button>
          <button className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 transition-colors" data-id="element-578">
            Successivo
          </button>
        </div>
      </div>

      {/* Modals */}
      <NuovaRichiestaModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-579" />

      {pendingChange && <ConfirmSituazioneModal isOpen={isConfirmModalOpen} onClose={handleCancelChange} onConfirm={handleConfirmChange} currentStatus={pendingChange.currentStatus} newStatus={pendingChange.newStatus} companyName={pendingChange.companyName} data-id="element-580" />}
    </div>;
}